/* Meem Arabic: sitewide cart drawer | price breakdown, digital-only qty limit, midnight timer */
(() => {
  'use strict';
  const drawer = document.getElementById('meem-cart-drawer');
  if (!drawer || window.MeemDrawer?.build === '20261028-final') return;
  // If CSS/JS and Liquid are from different releases, don't render a broken cart.
  const required = [
    '[data-md-products]', '[data-cart-message]', '[data-cart-count]', '[data-cart-contents]',
    '[data-progress-label]', '[data-progress-bar]', '[data-progress-fill]',
    '[data-progress-message]', '[data-recommendations]', '[data-free-spotlight]',
    '[data-offer-bottom]', '[data-offer-bottom-heading]', '[data-offer-bottom-copy]',
    '[data-md-savings-row]', '[data-md-save-amount]', '[data-md-save-percent]',
    '[data-cart-total]', '[data-md-checkout-total]', '[data-discount-warning]',
    '[data-checkout]', '[data-md-clock]', '.md-cart-panel'
  ];
  const missing = required.filter(selector => !drawer.querySelector(selector));
  if (drawer.dataset.meemBuild !== '20261028-final' || missing.length) {
    console.error('[Meem Arabic] Cart files do not match. Replace BOTH sections/meem-bundle-cart-drawer.liquid and assets/meem-bundle-cart-drawer.js from the same package. Missing:', missing);
    return;
  }

  const panel = drawer.querySelector('.md-cart-panel');
  const by = (selector) => drawer.querySelector(selector);
  let config;
  try { config = JSON.parse(by('[data-md-products]').textContent); } catch (err) { return; }
  const base = (window.Shopify?.routes?.root || drawer.dataset.cartRoot || '/').replace(/\/?$/, '/');
  const ajax = (suffix) => base + suffix;
  let busy = false;
  let previousFocus = null;
  let actualCart = null;
  let revision = 0;
  let countdownInterval = null;

  // Visitor-local midnight display only. Shopify controls whether sale pricing/discount is active.
  const firstView = new Date();
  const countdownDeadline = new Date(firstView.getFullYear(), firstView.getMonth(), firstView.getDate() + 1, 0, 0, 0, 0).getTime();

  const money = (cents) => {
    // Shopify cart.js reports values in the customer's selected presentment currency.
    // Include ISO codes for ambiguous symbols ($ AUD / USD / CAD / NZD, etc.).
    const curr = String(actualCart?.currency || config.currency || window.Shopify?.currency?.active || 'AUD').toUpperCase();
    try {
      const formatted = new Intl.NumberFormat(config.locale || 'en-AU', {
        style: 'currency', currency: curr, currencyDisplay: 'narrowSymbol'
      }).format(Number(cents || 0) / 100);
      return `${formatted} ${curr}`;
    } catch (_) {
      return `${(Number(cents || 0) / 100).toFixed(2)} ${curr}`;
    }
  };
  const elem = (tag, className, label) => {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (label !== undefined) el.textContent = label;
    return el;
  };
  const msg = (message) => {
    const el = by('[data-cart-message]');
    el.textContent = message || '';
    el.hidden = !message;
  };

  async function request(url, body) {
    const options = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (body !== undefined) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    }
    const response = await fetch(url, options);
    let result;
    try { result = await response.json(); } catch (_) { throw new Error('Could not verify your cart. Please refresh.'); }
    if (!response.ok) throw new Error(result?.description || `Unable to update cart (${response.status}).`);
    return result;
  }

  function matchedProduct(item) {
    return config.products.find(product => String(product.variant) === String(item.variant_id));
  }
  function presentVariants(cart) {
    return new Set((cart.items || []).map(item => String(item.variant_id)));
  }

  function drawCountdown() {
    const clock = by('[data-md-clock]');
    if (!clock) return;
    const remaining = Math.max(0, Math.ceil((countdownDeadline - Date.now()) / 1000));
    if (!remaining) {
      clock.textContent = '00:00:00';
      by('.md-cart-mini-timer-label').textContent = "TODAY’S BUNDLE COUNTDOWN HAS ENDED";
      stopCountdown();
      return;
    }
    const hh = Math.floor(remaining / 3600);
    const mm = Math.floor((remaining % 3600) / 60);
    const ss = remaining % 60;
    clock.textContent = [hh, mm, ss].map(n => String(n).padStart(2, '0')).join(':');
  }
  function stopCountdown() {
    if (countdownInterval !== null) clearInterval(countdownInterval);
    countdownInterval = null;
  }
  function startCountdown() {
    drawCountdown();
    if (countdownDeadline > Date.now() && countdownInterval === null) {
      countdownInterval = setInterval(drawCountdown, 1000);
    }
  }

  // If a separate product page added several copies, reduce ONLY these 4 digital bundles to one each.
  // Physical products keep their normal quantity controls and quantity.
  async function enforceSingleDigitalBundle(cart) {
    for (let attempts = 0; attempts < 12; attempts++) {
      const item = (cart.items || []).find(line => matchedProduct(line) && Number(line.quantity) > 1);
      if (!item) return cart;
      await request(ajax('cart/change.js'), { id: item.key, quantity: 1 });
      cart = await request(ajax('cart.js'));
    }
    return cart;
  }

  function showPriceBreakdown(cart, bundleCount) {
    // Based on Shopify's CURRENT cart. Never manufacture a discount.
    let compareAtTotal = 0;
    for (const line of (cart.items || [])) {
      const product = matchedProduct(line);
      const originalLine = Number(line.original_line_price || 0);
      // Include Starter Pack compare-at value in savings calculation
const starterCompareLine =
  Number(config.starterCompare?.[String(line.variant_id)] || 0) *
  Number(line.quantity || 1);

const compareAtLine =
  product && Number(product.compare) > Number(product.price)
    ? Number(product.compare) * Number(line.quantity)
    : Math.max(
        originalLine,
        starterCompareLine
      );
      compareAtTotal += Math.max(compareAtLine, originalLine);
    }
    const finalTotal = Number(cart.total_price || 0);
    const savings = Math.max(0, compareAtTotal - finalTotal);
    const percent = compareAtTotal > 0 ? Math.round((savings / compareAtTotal) * 100) : 0;
    by('[data-md-savings-row]').hidden = savings <= 0;
    by('[data-md-save-amount]').textContent = money(savings);
    by('[data-md-save-percent]').textContent = savings > 0 ? `(${percent}% OFF)` : '';
    by('[data-cart-total]').textContent = money(finalTotal);
    by('[data-md-checkout-total]').textContent = money(finalTotal);

    const freeBundleApplied = (cart.items || []).some(line =>
      matchedProduct(line) && Number(line.original_line_price) > 0 && Number(line.final_line_price) === 0
    );
    by('[data-discount-warning]').hidden = bundleCount !== 4 || freeBundleApplied;
  }

  function render(cart) {
    actualCart = cart;
    by('[data-cart-count]').textContent = String(cart.item_count);
    const contents = by('[data-cart-contents]');
    contents.replaceChildren();
    const present = presentVariants(cart);
    const bundleCount = config.products.filter(p => p.variant && present.has(String(p.variant))).length;
    // Lets CSS adapt recommendation card sizes to the number of items.
    drawer.dataset.bundleCount = String(bundleCount);
    drawer.dataset.bundleOnly = String((cart.items || []).every(item => Boolean(matchedProduct(item))));

    if (!cart.items.length) {
      const empty = elem('div', 'md-cart-empty');
      empty.append(
        elem('span', null, '♡'),
        elem('h3', null, 'Your Arabic learning starts here.'),
        elem('p', null, 'Choose a worksheet bundle and make a little space for Arabic learning.')
      );
      const goHome = elem('a', 'md-cart-continue', 'Explore worksheet bundles');
      goHome.href = base + '#meem-bundles';
      empty.append(goHome);
      contents.append(empty);
    } else {
      const list = elem('ul', 'md-cart-list');
      for (const item of cart.items) {
        const product = matchedProduct(item);
        const free = Number(item.final_line_price) === 0 && Number(item.original_line_price) > 0;
        const row = elem('li', 'md-cart-item');
        const link = elem('a');
        link.href = item.url || product?.link || base;
        link.setAttribute('aria-label', item.product_title);
        const imageSrc = product?.image || item.featured_image?.url || item.image || '';
        if (imageSrc) {
          const picture = elem('img', 'md-cart-item-media');
          picture.src = imageSrc;
          picture.width = 78;
          picture.height = 90;
          picture.loading = 'lazy';
          picture.alt = item.product_title;
          link.append(picture);
        }
        row.append(link);
        const main = elem('div', 'md-cart-item-main');
        const title = elem('a', 'md-cart-item-title', item.product_title);
        title.href = link.href;
        main.append(title);
        if (free) main.append(elem('span', 'md-cart-item-free-tag', '4TH BUNDLE FREE'));
        row.append(main);

        const actions = elem('div', 'md-cart-item-actions');
        if (!product) {
          // Physical products and unrelated items retain quantity controls.
          const controls = elem('div', 'md-cart-qty');
          const minus = elem('button', null, '−');
          minus.type = 'button';
          minus.setAttribute('aria-label', `Decrease ${item.product_title} quantity`);
          minus.dataset.cartQty = '';
          minus.dataset.key = item.key;
          minus.dataset.quantity = String(Math.max(0, item.quantity - 1));
          const qty = elem('b', null, String(item.quantity));
          const plus = elem('button', null, '+');
          plus.type = 'button';
          plus.setAttribute('aria-label', `Increase ${item.product_title} quantity`);
          plus.dataset.cartQty = '';
          plus.dataset.key = item.key;
          plus.dataset.quantity = String(item.quantity + 1);
          controls.append(minus, qty, plus);
          actions.append(controls);
        }
        const remove = elem('button', 'md-cart-remove', 'Remove');
        remove.type = 'button';
        remove.dataset.cartQty = '';
        remove.dataset.key = item.key;
        remove.dataset.quantity = '0';
        remove.setAttribute('aria-label', `Remove ${item.product_title} from cart`);
        actions.append(remove);
        row.append(actions);

        // Two stacked amounts, as requested: crossed-out original ABOVE
        // the green current amount. A zero-priced bonus reads FREE.
        const prices = elem('div', 'md-cart-item-prices');
        // Compare-at prices for worksheet bundles and Starter Pack
const starterCompare =
  Number(config.starterCompare?.[String(item.variant_id)] || 0) *
  Number(item.quantity || 1);

const compareAt =
  product && Number(product.compare) > Number(product.price)
    ? Number(product.compare) * Number(item.quantity)
    : Math.max(
        starterCompare,
        Number(item.original_line_price || 0)
      );
        if (compareAt > Number(item.final_line_price || 0)) {
          prices.append(elem('s', 'md-cart-item-original', money(compareAt)));
        }
        prices.append(elem('strong', 'md-cart-item-current', free ? 'FREE' : money(item.final_line_price)));
        row.append(prices);
        list.append(row);
      }
      contents.append(list);
    }

    const missing = config.products.filter(p => p.variant && !present.has(String(p.variant)) && p.available);
    by('[data-progress-label]').textContent = `${bundleCount} of 4 bundles`;
    by('[data-progress-bar]').setAttribute('aria-valuenow', String(bundleCount));
    by('[data-progress-fill]').style.width = `${bundleCount * 25}%`;
    const progressCopy = [
      'Pick a first bundle and build from there.',
      'Add 2 more to unlock a FREE fourth.',
      'Add 1 more to unlock a FREE fourth.',
      'Choose your fourth bundle FREE!',
      '✦ Full collection - fourth bundle FREE!'
    ];
    by('[data-progress-message]').textContent = progressCopy[bundleCount];
    const recommended = by('[data-recommendations]');
    recommended.replaceChildren();
    const freeSpotlight = by('[data-free-spotlight]');
    freeSpotlight.hidden = bundleCount !== 3;
    const offerBottom = by('[data-offer-bottom]');
    offerBottom.hidden = !cart.items.length;
    const valueCopy = [
      ['Your learning, your way.', 'Choose from letters, reading, everyday Arabic and playful activities.'],
      ['A little more to discover.', 'Each collection gives your learner a different way to practise.'],
      ['Halfway to the complete collection.', 'Keep adding activities that suit your learner’s next step.'],
      ['One last collection to explore.', 'Add your free fourth bundle to complete your printable library.'],
      ['Four bundles, one complete library.', 'Letter practice, reading, everyday words and fun activities—ready to use.']
    ][bundleCount];
    by('[data-offer-bottom-heading]').textContent = valueCopy[0];
    by('[data-offer-bottom-copy]').textContent = valueCopy[1];
    if (bundleCount === 4) {
      const complete = elem('div', 'md-cart-complete');
      complete.append(elem('strong', 'md-cart-complete-title', '✓ Your complete collection is ready!'));
      const covers = elem('div', 'md-cart-complete-covers');
      for (const p of config.products) {
        if (!p.image) continue;
        const img = elem('img');
        img.src = p.image;
        img.alt = p.title;
        img.width = 80;
        img.height = 100;
        img.loading = 'lazy';
        covers.append(img);
      }
      complete.append(covers);
      complete.append(elem('p', 'md-cart-complete-copy', 'You have all four ways to explore Arabic!'));
      recommended.append(complete);
    } else {
      for (const p of missing) {
        const card = elem('article', 'md-cart-pick');
        if (p.image) {
          const img = elem('img');
          img.src = p.image;
          img.width = 60;
          img.height = 72;
          img.alt = p.title;
          img.loading = 'lazy';
          card.append(img);
        } else card.append(elem('div', null, '📚'));
        const content = elem('div');
        content.append(elem('h3', null, p.title));
        const descriptions = {
          'Arabic Alphabet': 'Letters, shapes & handwriting',
          'Reading & Vocabulary': 'Words, matching & early reading',
          'Arabic Essentials': 'Numbers, feelings & everyday words',
          'Fun Activities': 'Mazes, colouring & playful practice'
        };
        const description = elem('p', 'md-cart-pick-desc', descriptions[p.title] || 'Ready-to-use Arabic worksheets');
        content.append(description);
        const price = elem('div', 'md-cart-pick-price');
        // When exactly THREE distinct worksheet bundles are in the cart,
        // the remaining fourth is advertised as FREE with the 4-for-3 offer.
        // Shopify must still apply the actual discount once it is added.
        const freeFourthOffer = bundleCount === 3;
        if (freeFourthOffer) {
          price.append(elem('strong', 'md-cart-free-price', 'FREE'));
          price.append(elem('s', null, money(p.price)));
          price.append(elem('span', 'md-cart-badge md-cart-badge-free', '4TH BUNDLE FREE'));
        } else {
          price.append(elem('strong', null, money(p.price)));
          if (p.compare > p.price) {
            price.append(elem('s', null, money(p.compare)));
            price.append(elem('span', 'md-cart-badge', `${Math.round((p.compare - p.price) * 100 / p.compare)}% OFF`));
          }
        }
        const add = elem('button', null, freeFourthOffer ? '+ Add FREE bundle' : '+ Add bundle');
        add.type = 'button';
        add.setAttribute('aria-label', freeFourthOffer ? `Add ${p.title} as your FREE fourth bundle` : `Add ${p.title} to cart`);
        add.dataset.suggestVariant = String(p.variant);
        content.append(price, add);
        card.append(content);
        recommended.append(card);
      }
    }
    // GOLD STAR STARTER PACK — COMPACT DIGITAL BONUS

const starterPackInCart = (cart.items || []).some(item =>
  item.handle === 'gold-star-arabic-starter-pack' ||
  /\/products\/gold-star-arabic-starter-pack(?:\?|$)/.test(item.url || '')
);

// Apply special styling only when the Starter Pack is in the cart.
drawer.classList.toggle(
  'md-cart-has-starter',
  starterPackInCart
);

// MEEM ARABIC — STARTER PACK NEXT STEPS

let starterNext = by('[data-starter-next]');

if (starterPackInCart && !starterNext) {

  const offerSection = by('[data-collection-section]');

  if (offerSection) {

    starterNext = document.createElement('section');

    starterNext.className = 'md-cart-starter-next';
    starterNext.setAttribute('data-starter-next', '');

    starterNext.innerHTML = `
      <div class="md-cart-starter-next-inner">

        <div class="md-cart-next-eyebrow">
          ✦ YOUR ARABIC ADVENTURE STARTS HERE
        </div>

        <h3 class="md-cart-next-heading">
          What happens after checkout?
        </h3>

        <ol class="md-cart-next-list">

          <li>
            <span class="md-cart-next-number">01</span>

            <div>
              <strong>Your order is confirmed</strong>
              <p>
                We'll email your order confirmation
                and purchase details.
              </p>
            </div>

            <span class="md-cart-next-icon">✓</span>
          </li>

          <li>
            <span class="md-cart-next-number">02</span>

            <div>
              <strong>Your digital library arrives</strong>
              <p>
                Receive a separate email with access
                to 1,000+ printable Arabic worksheets.
              </p>
            </div>

            <span class="md-cart-next-icon">✉</span>
          </li>

          <li>
            <span class="md-cart-next-number">03</span>

            <div>
              <strong>Your physical pack is on its way</strong>
              <p>
                We'll prepare your full-colour workbooks,
                flashcards and accessories, then send tracking
                details when dispatched.
              </p>
            </div>

            <span class="md-cart-next-icon">✦</span>
          </li>

        </ol>

        <div class="md-cart-next-footer">
          💛 Everything for their next little learning adventure.
        </div>

      </div>
    `;

    offerSection.insertAdjacentElement(
      'afterend',
      starterNext
    );

  }

}

// Show only when Starter Pack is in cart
if (starterNext) {
  starterNext.hidden = !starterPackInCart;
}

// END STARTER PACK NEXT STEPS

const collectionTitle = by(
  '[data-collection-section] .md-cart-offer-top span'
);

if (collectionTitle) {
  collectionTitle.textContent = starterPackInCart
    ? '🎁 YOUR DIGITAL LIBRARY IS INCLUDED'
    : 'COMPLETE YOUR ARABIC LIBRARY';
}

// Hide worksheet-bundle promotions for Starter Pack customers.
by('[data-progress-label]').hidden = starterPackInCart;
by('[data-progress-bar]').hidden = starterPackInCart;
by('[data-progress-message]').hidden = starterPackInCart;
by('[data-md-midnight]').hidden = starterPackInCart;

if (starterPackInCart) {

  const included = elem('div', 'md-cart-starter-bonus');

  // Main message
  const heading = elem(
    'h3',
    'md-cart-starter-heading',
    '1,000+ printable worksheets. Yours to enjoy!'
  );

  const description = elem(
    'p',
    'md-cart-starter-description',
    'Your Gold Star Starter Pack includes complimentary lifetime access to our complete Arabic digital worksheet library.'
  );

  included.append(heading, description);

  // Compact benefits
  const benefits = elem('div', 'md-cart-starter-benefits');

  const benefitsList = [
    'All 4 collections',
    'Lifetime access',
    'Organised PDF files',
    'Instant digital delivery'
  ];

  benefitsList.forEach(label => {

    const benefit = elem(
      'span',
      'md-cart-starter-benefit',
      '✓ ' + label
    );

    benefits.append(benefit);

  });

  included.append(benefits);

  // Digital delivery reminder
  const emailNote = elem(
    'div',
    'md-cart-starter-email',
    '💌 Your digital access links will arrive in a separate email after purchase.'
  );

  included.append(emailNote);

  // Warn if separately purchased digital bundles are also in cart.
  if (bundleCount > 0) {

    const warning = elem(
      'p',
      'md-cart-starter-warning',
      'You also have separately priced digital bundles in your cart. Remove them if you only want the digital library included with your Starter Pack.'
    );

    included.append(warning);
  }

  // Replace recommendations with the complimentary bonus card.
  recommended.replaceChildren(included);

  by('[data-free-spotlight]').hidden = true;
  by('[data-offer-bottom]').hidden = true;
}

// END STARTER PACK BONUS
    showPriceBreakdown(cart, bundleCount);
    const checkout = by('[data-checkout]');
    checkout.setAttribute('aria-disabled', cart.item_count ? 'false' : 'true');
    checkout.href = base + 'checkout';
    document.querySelectorAll('[data-meem-cart-count]').forEach(el => {
      el.textContent = String(cart.item_count);
    });
  }

  async function refresh() {
    const rev = ++revision;
    let cart = await request(ajax('cart.js'));
    cart = await enforceSingleDigitalBundle(cart);
    if (rev === revision) render(cart);
    return cart;
  }
  async function open() {
    if (drawer.hidden) {
      previousFocus = document.activeElement;
      drawer.hidden = false;
      document.body.dataset.meemCartDrawerOpen = 'true';
      document.body.style.overflow = 'hidden';
      panel.focus();
      startCountdown();
    }
    try { msg('Loading your cart…'); await refresh(); msg(''); } catch (err) { msg(err.message || 'Unable to load the cart. Please refresh.'); }
  }
  function close() {
    drawer.hidden = true;
    stopCountdown();
    document.body.style.overflow = '';
    delete document.body.dataset.meemCartDrawerOpen;
    previousFocus?.focus?.();
  }
  async function perform(body, endpoint) {
    if (busy) return;
    busy = true;
    drawer.querySelectorAll('button').forEach(button => { button.disabled = true; });
    msg('Updating your cart…');
    try {
      await request(endpoint, body);
      const cart = await refresh();
      msg('');
      document.dispatchEvent(new CustomEvent('meem:cart-updated', { detail: { cart } }));
    } catch (err) {
      msg(err.message + ' Check your cart before trying again.');
    } finally {
      busy = false;
      drawer.querySelectorAll('button').forEach(button => { button.disabled = false; });
    }
  }

  drawer.addEventListener('click', event => {
    if (event.target.closest('[data-close-drawer]')) { close(); return; }
    const quantityButton = event.target.closest('[data-cart-qty]');
    if (quantityButton) {
      perform({ id: quantityButton.dataset.key, quantity: Number(quantityButton.dataset.quantity) }, ajax('cart/change.js'));
      return;
    }
    const recommendation = event.target.closest('[data-suggest-variant]');
    if (recommendation) {
      // Never increment the quantity of a digital bundle that's already there.
      const variant = String(recommendation.dataset.suggestVariant);
      if (actualCart?.items?.some(item => String(item.variant_id) === variant)) return;
      perform({ items: [{ id: Number(variant), quantity: 1 }] }, ajax('cart/add.js'));
    }
  });
  drawer.addEventListener('keydown', event => {
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    const focusable = [...drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])')]
      .filter(el => el.getClientRects().length);
    if (!focusable.length) return;
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { last.focus(); event.preventDefault(); }
    else if (!event.shiftKey && document.activeElement === last) { first.focus(); event.preventDefault(); }
  });
  document.addEventListener('click', event => {
    if (drawer.contains(event.target)) return;
    const anchor = event.target.closest('a[href]');
    if (anchor) {
      let url;
      try { url = new URL(anchor.href, location.href); } catch (_) { return; }
      if (url.origin === location.origin && /(?:^|\/)cart\/?$/.test(url.pathname)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        open();
        return;
      }
    }
    const opener = event.target.closest(
      '[data-open-meem-cart], header-actions [data-testid="cart-drawer-trigger"], header-actions button[aria-controls="cart-drawer"], header-actions a.action__cart'
    );
    if (opener) {
      // Horizon's native cart icon is a button, not an /cart link.
      // Capture the click before Horizon opens its own drawer.
      event.preventDefault();
      event.stopImmediatePropagation();
      open();
    }
  }, true);
  document.addEventListener('meem:cart-updated', () => {
    if (!drawer.hidden && !busy) refresh().catch(err => msg(err.message));
  });
  window.MeemDrawer = { open, close, refresh, build: '20261028-final' };
  if (new URLSearchParams(location.search).has('open_cart')) open();
})();
